import axios, { AxiosInstance } from 'axios';
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { differenceInCalendarDays } from 'date-fns';
import { TimeZone } from '../models/enums/settings';
import ControllCallByPaymentTypes from '../models/interfaces/callByPaymentTypes';
import { doc, limitsByPaymentsTypesCollection } from '../config/firebase';
import Tariff from '../models/interfaces/tariff';
import { DriverSql } from '../models/interfaces/sql/driverSql';
import { CallSql } from '../models/interfaces/sql/callSql';

export default class SupabaseService {
    api: AxiosInstance;

    supabase: SupabaseClient;

    supabaseKey = '';

    constructor() {
      // eslint-disable-next-line max-len
      this.supabaseKey = process.env.REACT_APP_SUPABASE_API_KEY ?? 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBvamxlbHhqZW5mcm16ZWFmdWtmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjcyOTgzNjcsImV4cCI6MjA0Mjg3NDM2N30.S5VKlQyAxCbwSgXS9bxP5GGEQrDQIObU2v3lM-MHYj4';
      this.api = axios.create({ baseURL: 'https://pojlelxjenfrmzeafukf.supabase.co' });
      this.supabase = createClient(process.env.REACT_APP_SUPABASE_URL ?? 'https://pojlelxjenfrmzeafukf.supabase.co', this.supabaseKey);
    }

    getConfig() {
      const config = {
        headers: {
          apikey: this.supabaseKey,
          Authorization: `Bearer ${this.supabaseKey}`,
          'Content-Type': 'application/json'
        }
      };
      return config;
    }

    // async getCall(subsidiaryId: string | undefined | null) {
    //   // subsidiaryId: string | undefined | null, timezone: string | null
    //   const startTimestamp = subHours(new Date(), 5).toISOString();
    //   console.log(startTimestamp);
    //   const currentTimestamp = new Date().toISOString();
    //   console.log(currentTimestamp);

    //   let query = this.supabase
    //     .from('calls')
    //     .select('*')
    //     .lte('createdat', startTimestamp)
    //     .gte('createdat', currentTimestamp);
    //   if (subsidiaryId) { query = query.eq('subsidiaryid', subsidiaryId); }
    //   const resp = await query;
    //   return resp;
    // }

    async getCallsByMonth(subsidiaryId: string | undefined | null, timezone: string | null, year: number) {
      const config = this.getConfig();
      const subsidiary = subsidiaryId ? `subsidiaryid=eq.${subsidiaryId}&` : '';
      const environment = process.env.REACT_APP_ADMIN_PROJECT_ID;
      let viewName = 'vicallstimezoneamericasao_paulo';
      switch (timezone) {
        case TimeZone.AmericaManaus: viewName = 'vicallstimezoneamericamanaus';
          break;
        case TimeZone.AmericaRioBranco: viewName = 'vicallstimezoneamerica_riobranco';
          break;
        default:
          break;
      }
      const endpoint = `rest/v1/${viewName}?year=eq.${year}&environment=eq.${environment}&${subsidiary}select=*`;
      return this.api.get(endpoint, config).then((response) => response?.data).catch((error) => console.warn(error));
    }

    async getCallsDaysApi(days: number, subsidiaryId: string | undefined | null, timezone: string | null) {
      const config = this.getConfig();
      const subsidiary = subsidiaryId ? `subsidiaryid=eq.${subsidiaryId}&` : '';
      const environment = process.env.REACT_APP_ADMIN_PROJECT_ID;
      const daysFilter = days ? `daysdiff=lte.${days}&` : '';
      let viewName = 'vicalls30daysamerica_saopaulo';

      switch (timezone) {
        case TimeZone.AmericaManaus: viewName = 'vicalls30daysamerica_manaus';
          break;
        case TimeZone.AmericaSaoPaulo: viewName = 'vicalls30daysamerica_saopaulo';
          break;
        case TimeZone.AmericaRioBranco: viewName = 'vicalls30daysamerica_riobranco';
          break;
        default: viewName = 'vicalls30daysamerica_saopaulo';
          break;
      }
      const endpoint = `rest/v1/${viewName}?environment=eq.${environment}&${daysFilter}${subsidiary}select=*`;
      return this.api.get(endpoint, config).then((response) => response?.data).catch((error) => console.warn(error));
    }

    getTopClients(subsidiaryId: string | undefined | null) {
      const config = this.getConfig();
      const subsidiary = subsidiaryId ? `subsidiaryid=eq.${subsidiaryId}&` : '';
      const environment = process.env.REACT_APP_ADMIN_PROJECT_ID;
      const viewName = 'vitop10weekclients';
      const endpoint = `rest/v1/${viewName}?status=eq.complete&environment=eq.${environment}&${subsidiary}select=*`;
      console.log(endpoint);
      return this.api.get(endpoint, config).then((response) => response?.data).catch((error) => console.warn(error));
    }

    getTopDrivers(subsidiaryId: string | undefined | null) {
      const config = this.getConfig();
      const subsidiary = subsidiaryId ? `subsidiaryid=eq.${subsidiaryId}&` : '';
      const environment = process.env.REACT_APP_ADMIN_PROJECT_ID;
      const viewName = 'vitop10weekdrivers';
      const endpoint = `rest/v1/${viewName}?status=eq.complete&environment=eq.${environment}&${subsidiary}select=*`;
      return this.api.get(endpoint, config).then((response) => response?.data).catch((error) => console.warn(error));
    }

    async getLimitsByPaymentsTypes(subsidiaryId: string | undefined | null) {
      const config = this.getConfig();
      const subsidiary = subsidiaryId ? `subsidiaryid=eq.${subsidiaryId}&` : '';
      const environment = process.env.REACT_APP_ADMIN_PROJECT_ID;
      const viewName = 'limitsByPaymentsTypes';
      const endpoint = `rest/v1/${viewName}?environment=eq.${environment}&${subsidiary}select=*`;
      return this.api.get(endpoint, config).then((response) => response?.data).catch((error) => console.warn(error));
    }

    async createLimitsByPaymentsTypes(body: ControllCallByPaymentTypes) {
      const config = this.getConfig();
      // const subsidiary = subsidiaryId ? `subsidiaryid=eq.${subsidiaryId}&` : '';
      const environment = process.env.REACT_APP_ADMIN_PROJECT_ID;
      const viewName = 'limitsByPaymentsTypes';
      const endpoint = `rest/v1/${viewName}`;
      const idDoc = doc(limitsByPaymentsTypesCollection).id;
      const reg = {
        id: idDoc,
        enabled: body.enabled,
        subsidiaryid: body.subsidiaryId,
        drivercategory: body.driverCategory,
        paymenttypecontrolled: body.paymentTypeControlled,
        parcentualmaxvalue: body.parcentualMaxValue,
        parcentualminvalue: body.parcentualMinValue ?? 0,
        paymenttypetarget: body.paymentTypeTarget,
        accumulation: body.accumulation,
        environment: environment ?? ''
      };
      return this.api.post(endpoint, [reg], config).then((response) => response?.data).catch((error) => console.warn(error));
    }

    async getCallsComplete15Days(subsidiaryId: string | undefined | null) {
      const config = this.getConfig();
      const subsidiary = subsidiaryId ? `subsidiaryid=eq.${subsidiaryId}&` : '';
      const environment = process.env.REACT_APP_ADMIN_PROJECT_ID;
      const viewName = 'callscomplete15days';
      const endpoint = `rest/v1/${viewName}?environment=eq.${environment}&${subsidiary}select=*`;
      return this.api.get(endpoint, config).then((response) => response?.data).catch((error) => console.warn(error));
    }

    async saveTariffs(body: Tariff) {
      const config = this.getConfig();
      const subsidiary = body.subsidiary ? `subsidiaryid=eq.${body.subsidiary}&` : '';
      const environment = process.env.REACT_APP_ADMIN_PROJECT_ID;
      const viewName = 'drivers';
      const endpoint = `rest/v1/${viewName}?environment=eq.${environment}&${subsidiary}select=*`;
      return this.api.post(endpoint, body, config).then((response) => response?.data).catch((error) => console.warn(error));
    }

    async getTariffs(subsidiaryId: string | undefined | null) {
      const config = this.getConfig();
      const subsidiary = subsidiaryId ? `subsidiaryid=eq.${subsidiaryId}&` : '';
      const environment = process.env.REACT_APP_ADMIN_PROJECT_ID;
      const viewName = 'tariffs';
      const endpoint = `rest/v1/${viewName}?environment=eq.${environment}&${subsidiary}select=*`;
      return this.api.get(endpoint, config).then((response) => response?.data).catch((error) => console.warn(error));
    }

    async addDriver(newDriver: DriverSql) {
      const { data, error } = await this.supabase
        .from<DriverSql>('drivers')
        .upsert(newDriver);
      return { data, error };
    }

    async getCallsDetailedByMonth(
      subsidiaryId: string,
      subsidiaryName: string | null,
      startDate: Date,
      endDate: Date,
      timezone: string | null
    ) {
      const environment = process.env.REACT_APP_ADMIN_PROJECT_ID ?? '';
      let offset = '-03:00';
      switch (timezone) {
        case TimeZone.AmericaManaus:
          offset = '-04:00';
          break;
        case TimeZone.AmericaRioBranco:
          offset = '-05:00';
          break;
        default:
          break;
      }

      const pad = (value: number) => String(value).padStart(2, '0');
      const toOffsetIso = (date: Date, hours: number, minutes: number, seconds: number) => (
        `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(hours)}:${pad(minutes)}:${pad(seconds)}${offset}`
      );
      const start = toOffsetIso(startDate, 0, 0, 0);
      const end = toOffsetIso(endDate, 23, 59, 59);

      const pageSize = 1000;
      const all: CallSql[] = [];
      let from = 0;
      const orFilter = subsidiaryName
        ? `subsidiaryid.eq.${subsidiaryId},subsidiaryname.eq."${subsidiaryName.replace(/"/g, '')}"`
        : null;
      const columns = [
        'id,complete,device,driverid,drivername,drivercategory,destinations,hasback',
        'clientid,clientname,paymentreturnvalue,paymenttype,paymentvalue,subsidiaryfeeperc',
        'status,stage,saleschannelname,subsidiaryid,subsidiaryname,createdat,canceledat,doc'
      ].join(',');

      while (from < 50000) {
        let query = this.supabase
          .from<CallSql>('calls')
          .select(columns)
          .eq('environment', environment)
          .gte('createdat', start)
          .lte('createdat', end)
          .order('createdat', { ascending: false })
          .range(from, from + pageSize - 1);

        if (orFilter) {
          query = query.or(orFilter);
        } else {
          query = query.eq('subsidiaryid', subsidiaryId);
        }

        // Paginação sequencial exigida pelo limite de 1000 linhas do PostgREST
        // eslint-disable-next-line no-await-in-loop
        const { data, error } = await query;
        if (error) throw new Error(error.message);
        const rows = data ?? [];
        all.push(...rows);
        if (rows.length < pageSize) break;
        from += pageSize;
      }

      return all;
    }

    async getCallsForAdjustment(params: {
      subsidiaryId: string;
      subsidiaryName: string | null;
      startDate: Date;
      endDate: Date;
      timezone: string | null;
      status: string | null;
      clientName: string | null;
    }) {
      const {
        subsidiaryId, subsidiaryName, startDate, endDate, timezone, status, clientName
      } = params;

      if (endDate < startDate) {
        throw new Error('A data final deve ser posterior à data inicial');
      }
      if (differenceInCalendarDays(endDate, startDate) > 15) {
        throw new Error('O período máximo da consulta é de 15 dias');
      }

      const environment = process.env.REACT_APP_ADMIN_PROJECT_ID ?? '';
      let offset = '-03:00';
      switch (timezone) {
        case TimeZone.AmericaManaus:
          offset = '-04:00';
          break;
        case TimeZone.AmericaRioBranco:
          offset = '-05:00';
          break;
        default:
          break;
      }

      const pad = (value: number) => String(value).padStart(2, '0');
      const toOffsetIso = (date: Date, hours: number, minutes: number, seconds: number) => (
        `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(hours)}:${pad(minutes)}:${pad(seconds)}${offset}`
      );
      const start = toOffsetIso(startDate, 0, 0, 0);
      const end = toOffsetIso(endDate, 23, 59, 59);
      const pageSize = 1000;
      const all: CallSql[] = [];
      let from = 0;
      const orFilter = subsidiaryName
        ? `subsidiaryid.eq.${subsidiaryId},subsidiaryname.eq."${subsidiaryName.replace(/"/g, '')}"`
        : null;
      const columns = 'id,clientname,drivername,status,createdat,doc';
      const safeClient = (clientName ?? '').trim().replace(/[%_]/g, '');

      while (from < 50000) {
        let query = this.supabase
          .from<CallSql>('calls')
          .select(columns)
          .eq('environment', environment)
          .gte('createdat', start)
          .lte('createdat', end)
          .order('createdat', { ascending: false })
          .range(from, from + pageSize - 1);

        if (orFilter) {
          query = query.or(orFilter);
        } else {
          query = query.eq('subsidiaryid', subsidiaryId);
        }
        if (status) query = query.eq('status', status);
        if (safeClient) query = query.ilike('clientname', `%${safeClient}%`);

        // Paginação sequencial exigida pelo limite de 1000 linhas do PostgREST
        // eslint-disable-next-line no-await-in-loop
        const { data, error } = await query;
        if (error) throw new Error(error.message);
        const rows = data ?? [];
        all.push(...rows);
        if (rows.length < pageSize) break;
        from += pageSize;
      }

      return all;
    }
}
